import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  name: string | null
  iataCode: string | null
  locationCode: string | null
  label: string | null
  offset: number
  limit: number
  total: number
  currentPage: number
}

export class FormData implements IFormData {

  name: string | null
  iataCode: string | null
  locationCode: string | null
  label: string | null
  offset: number
  limit: number
  total: number
  currentPage: number

  constructor() {
    this.name = null;
    this.iataCode = null;
    this.locationCode = null;
    this.label = null;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;

  }

}
